import React, { useContext, useEffect, useState, useRef } from "react";
import Header3 from "../components/Header3";

import { Card, Carousel, Form, InputGroup } from "react-bootstrap";
import Footer3 from "../components/Footer3";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import leftArrow from "./image/moveimgarrow.png"; // Left arrow
import rightArrow from "./image/moveimgarrow.png"; // Right arrow (same image, rotated)
import Footer2 from "../components/Footer2";
import axios from "../AxiosInstance";
import { useAuth } from "../context/auth";
import { BASE_URL } from "../config/BaseUrls";
import { LanguageContext } from "../context/LanguageContext";
import { resolveBookImageUrl } from "../utils/urlHelpers";

const BooksAndReviews2 = () => {
  const { lg } = useContext(LanguageContext);

  const navigate = useNavigate();

  // SAERCH BOOK SUGGESTION

  const [ratedBooks, setRatedBooks] = useState();
  const [booksByHeading, setBooksByHeading] = useState({});
  const [headings, setHeadings] = useState([]);
  const [bookCount, setBookCount] = useState(0);
  const [bookCount1, setBookCount1] = useState(0);
  const CustomPrevArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <img
        src={leftArrow}
        alt="Previous"
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          left: "-20px", // Adjust position
          top: "40%",
          transform: "translateY(-50%) rotate(180deg)", // Rotate left arrow
          width: "15px",
          height: "15px",
          cursor: "pointer",
          zIndex: 1, // Ensure it's above other elements
        }}
        onClick={(e) => {
          e.stopPropagation(); // Prevent default event bubbling
          if (typeof onClick === "function") {
            onClick();
          }
        }}
      />
    );
  };

  const CustomNextArrow = (props) => {
    const { className, style, onClick } = props;
    return (
      <img
        src={rightArrow}
        alt="Next"
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          right: "-20px", // Adjust position
          top: "40%",
          transform: "translateY(-50%) rotate(0deg)",
          width: "15px",
          height: "15px",
          cursor: "pointer",
          zIndex: 1,
        }}
        onClick={(e) => {
          e.stopPropagation(); // Prevent default event bubbling
          if (typeof onClick === "function") {
            onClick();
          }
        }}
      />
    );
  };
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: Math.min(8, bookCount),
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    arrows: bookCount > 1, // Show arrows only if there's more than 1 book
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    centerMode: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: Math.min(3, bookCount),
          arrows: bookCount > 3,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: Math.min(2.2, bookCount),
          arrows: bookCount > 2,
          arrows: false,
        },
      },
      {
        breakpoint: 390,
        settings: {
          slidesToShow: Math.min(2, bookCount),
          arrows: bookCount > 2,
          arrows: false,
        },
      },
    ],
  };
  const settingsd = {
    infinite: false,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    draggable: true,
    swipe: true,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    rtl: false,
    centerMode: false, // Enable centering only if enough items
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3.7,
          centerMode: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          centerMode: false,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 2.1,
          centerMode: false,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 2.2,
          centerMode: false,
          centerPadding: "20px",
          arrows: false,
        },
      },
      {
        breakpoint: 390,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          arrows: false,
        },
      },
    ],
  };

  const [searchQueryName, setSearchQueryName] = useState("");
  const [suggestionsName, setSuggestionsName] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const searchTimeoutRef = useRef(null);

  const handleInputNameChange = async (e) => {
    if (!e || !e.target) return;
    const value = e.target.value;
    setSearchQueryName(value);

    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    if (value.trim() === "") {
      setSuggestionsName([]);
      setSearchLoading(false);
      return;
    }

    // Debounce search - wait 300ms before making API call
    setSearchLoading(true);
    searchTimeoutRef.current = setTimeout(async () => {
      try {
        // Fetch from API
        const response = await axios.get(
          `api/search?query=${encodeURIComponent(value)}`
        );
        console.log("API Response:", response.data);

        if (response.data.success && Array.isArray(response.data.books)) {
          const formattedBooks = response.data?.books?.map((book) => ({
            bookId: book?.bookid,
            id: book.EAN,
            title: book["Title Derived"],
            author: book["First Contributor Name"],
            format: book["Product Form Description"],
            publisher: book["Publisher Imprint"],
            genre: book["1st BISAC Major Description"],
            aboutBook: book["AboutBook"],
            pageNumber: book["Page Number"],
            image: book.image,
            isBookDetail: book?.isBookDetail || false,
          }));
          setSuggestionsName(formattedBooks);
        } else {
          setSuggestionsName([]);
        }
      } catch (error) {
        console.error("Error fetching suggestions:", error);
        setSuggestionsName([]);
      } finally {
        setSearchLoading(false);
      }
    }, 300);
  };
  const handleSearchName = () => {
    if (searchQueryName.trim() !== "") {
      setSuggestionsName([]); // ✅ Reset when input is empty

      // navigate(`/reviews?bookid=${encodeURIComponent(searchQueryName)}`);
    }
  };
  const handleSuggestionClickName = (book) => {
    setSearchQueryName(book);
    setSuggestionsName([]);

    console.log("bookid click", book);
    const selectedBookObj = {
      bookId: book?.bookId,
      bookCoverImage: book.image, // <== This is correct
      title: book.title,
      author: book.author,
      descriptions: book.aboutBook, // ✅ add this
      titless: book.title,
      publisher: book.publisher,
      book: book,
      EAN: book.id, // 👈 Add EAN if available
      isSearchBook: book?.isBookDetail ? false : true,
    };
    console.log(
      "coverimage book",
      JSON.parse(localStorage.getItem("selectedBookforreviews"))
    );

    setSelectedBook(selectedBookObj);
    localStorage.setItem(
      "selectedBookforreviews",
      JSON.stringify(selectedBookObj)
    );
    localStorage.setItem(
      "selectedBookforreviewsnew",
      JSON.stringify(selectedBookObj)
    );
    const queryParam = book?.id
      ? `ean=${encodeURIComponent(book.id)}`
      : `bookid=${encodeURIComponent(book?.bookId)}`;

    const queryPar2 = book?.isOffilio
      ? `offilio=true`
      : book?.isBookDetail
        ? "bookdetail=true"
        : `searchbook=true`;

    navigate(`/reviews?${queryParam}&${queryPar2}`);
  };
  const handleSuggestionClickNameRecent = (book) => {
    console.log("bookid click", book);
    const selectedBookObj = {
      bookId: book?.isBookDetail ? book?.bookId : null, // 👈 Use book.id if available
      bookCoverImage: book.coverImage, // <== This is correct
      title: book.title,
      author: book.author,
      descriptions: book.aboutBook, // ✅ add this
      titless: book.title,
      publisher: book.publisher,
      book: book,
      EAN: book.EAN, // 👈 Add EAN if available
      isSearchBook: book?.isBookDetail ? false : true,
    };
    localStorage.setItem(
      "selectedBookforreviews",
      JSON.stringify(selectedBookObj)
    );
    localStorage.setItem(
      "selectedBookforreviewsnew",
      JSON.stringify(selectedBookObj)
    );
    const queryParam = book?.EAN
      ? `ean=${encodeURIComponent(book.EAN)}`
      : `bookid=${encodeURIComponent(book?.bookId)}`;

    const queryPar2 = book?.isOffilio
      ? `offilio=true`
      : book?.isBookDetail
        ? "bookdetail=true"
        : `searchbook=true`;

    navigate(`/reviews?${queryParam}&${queryPar2}`);
  };
  // Recently book Reviews
  const [selectedBook, setSelectedBook] = useState(null);
  const [slidesToShowConfig, setSlidesToShowConfig] = useState({});
  // OFEELIO SUGGECTIVE

  useEffect(() => {
    fetchHeadings();
  }, []);

  // Cleanup timeouts on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  const fetchHeadings = async () => {
    try {
      // Fetch from API
      console.log("🌐 Fetching headings from API");
      const response = await axios.get("api/v1/review/getoffelliotitle");
      const headingsData = response.data;
      setHeadings(headingsData);
      
      await fetchAllBooks(headingsData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching headings:", error);
      setLoading(false);
    }
  };

  const fetchAllBooks = async (headings) => {
    try {
      // Fetch from API
      console.log("🌐 Fetching books from API");
      const response = await axios.get(`/api/v1/admin/getAllBookCoverOfellio`);
      console.log(response?.data?.books.length, "books by heading");

      const booksData = response?.data?.books;
      setBooksByHeading(booksData);
      setSlidesToShowConfig(booksData?.length);
    } catch (error) {
      console.error("Error fetching books:", error);
    }
  };

  const [auth, setAuth] = useAuth(); // If using Context API

  const [loading, setLoading] = useState(true);
  const [ratedBooksLoading, setRatedBooksLoading] = useState(true);
  const userId = auth?.user?._id;

  useEffect(() => {
    const fetchRatedBooks = async () => {
      try {
        setRatedBooksLoading(true);

        // Fetch from API
        console.log("🌐 Fetching rated books from API");
        const response = await axios.get(`api/v1/review/recently-rated`);
        const booksData = response.data.books;
        setRatedBooks(booksData);
        setBookCount(booksData.length);
      } catch (error) {
        console.error("Error fetching rated books:", error);
      } finally {
        setRatedBooksLoading(false);
      }
    };

    fetchRatedBooks();
  }, [userId]);

  // if (loading) {
  //   return <div>Loading...</div>;
  // }

  const StarRating = ({ rating }) => {
    const totalStars = 5;

    return (
      <div>
        {Array.from({ length: totalStars }, (_, index) => (
          <span
            key={index}
            style={{
              fontSize: "21px",
              color: index < rating ? "#ffc107" : "#ddd", // Warning color for filled stars, light grey for empty stars
            }}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  // Skeleton Loader Component for Book Cards
  const BookSkeleton = () => (
    <Card className="border-0 align-items-center" style={{ width: "" }}>
      <div
        className="bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded relative overflow-hidden"
        style={{
          width: "110px",
          height: "160px",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.5s infinite",
        }}
      >
        <div
          className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
          style={{
            transform: "translateX(-100%)",
            animation: "shimmer-slide 1.5s infinite",
          }}
        ></div>
      </div>
      <Card.Body className="p-0 mt-1">
        <div className="mx-2">
          <div
            className="bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded"
            style={{
              width: "80px",
              height: "21px",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.5s infinite",
            }}
          ></div>
        </div>
      </Card.Body>
    </Card>
  );
  // New State to Save Clicked Book

  const handleBookClick = (book) => {
    console.log(book, "kjk");
    const selectedBookObj = {
      bookId: book._id, // 👈 Use book.id if available
      bookCoverImage: `${book.coverImage}`, // <== This is correct
      title: book.name,
      author: book.author,
      descriptions: book.discription, // ✅ add this
      titless: book.name,
      publisher: book.publisher,
      book: book,
      EAN: book.EAN, // 👈 Add EAN if available
      isSearchBook: false, // 👈 Add this if coming from searchbook
    };
    setSelectedBook(book); // Save the clicked book to state
    localStorage.setItem(
      "selectedBookforreviews",
      JSON.stringify(selectedBookObj)
    ); // Save it to localStorage
    localStorage.setItem(
      "selectedBookforreviewsnew",
      JSON.stringify(selectedBookObj)
    ); // Save it to localStorage
    navigate(`/reviews?bookid=${book._id}&offilio=true`);
  };

  return (
    <>
      <div className="book2heder">
        <Header3 />
      </div>

      <div className="alincenterawidth scalmin1">
        <div
          className="sm:mt-5 d-flex justify-content-center align-items-center  "
          style={{ backgroundColor: "transparent" }}
        >
          <InputGroup
            className="mt-5 w-100 mx-5  outline12"
            style={{ backgroundColor: "transparent", maxWidth: "560px" }}
          >
            <Form.Control
              className=" px-4 placeholder-1 fw600 fs-5 ftzinput"
              style={{
                backgroundColor: "transparent",

                lineHeight: "40px",

                color: "#595959",
              }}
              // placeholder="Search by book"
              placeholder={lg?.Srchbook}
              aria-label="Recipient's username"
              aria-describedby="basic-addon2"
              value={searchQueryName}
              onChange={handleInputNameChange}
              // onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={(e) => e.key === "Enter" && handleSearchName()}
            />
            <InputGroup.Text
              className="mobil144 border-0  py-1 px-2"
              id="basic-addon2"
              style={{
                width: "51px",
                height: "53px",
                marginTop: "-2px",
                // height: "51px",
                backgroundColor: "#34C3C9",
                marginRight: "-2px",
                cursor: "pointer",
                borderRadius: "0px 10px 10px 0",
              }}
              onClick={handleSearchName}
            >
              <img
                className="   mobilwid111 "
                src={require("../pages/image/searchwhite.png")}
                alt="logo"
              />
            </InputGroup.Text>
            <div
              style={{
                position: "absolute",
                width: "100%",
                maxHeight: "300px",
                maxWidth: "350px",
                overflowY: "auto",
                backgroundColor: "white",
                // border: "1px solid #ddd",
                borderRadius: "4px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                zIndex: 1000,
                marginTop: "60px",
              }}
            >
              {searchLoading ? (
                <div className="p-3">
                  <div className="d-flex align-items-center gap-2">
                    <div
                      className="bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded"
                      style={{
                        width: "30px",
                        height: "45px",
                        backgroundSize: "200% 100%",
                        animation: "shimmer 1.5s infinite",
                      }}
                    ></div>
                    <div className="flex-grow-1">
                      <div
                        className="bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded mb-2"
                        style={{
                          width: "80%",
                          height: "16px",
                          backgroundSize: "200% 100%",
                          animation: "shimmer 1.5s infinite",
                        }}
                      ></div>
                      <div
                        className="bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 rounded"
                        style={{
                          width: "60%",
                          height: "14px",
                          backgroundSize: "200% 100%",
                          animation: "shimmer 1.5s infinite",
                          animationDelay: "0.2s",
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              ) : suggestionsName.length > 0 ? (
                suggestionsName.map((book) => (
                  <div
                    key={book.id}
                    style={{
                      padding: "8px 12px",
                      cursor: "pointer",
                      borderBottom: "1px solid #eee",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={() => {
                      handleSuggestionClickName(book);

                      console.log("bookid click", book);
                    }}
                  // onClick={() => handleBookClick(book)}
                  >
                    {book.image && (
                      <img
                        src={
                       resolveBookImageUrl(book.image)
                        }

                        alt={book.title}
                        style={{
                          width: "30px",
                          height: "45px",
                          objectFit: "cover",
                          marginRight: "10px",
                        }}
                      />
                    )}
                    <div>
                      <div style={{ fontWeight: "bold" }}>{book.title}</div>
                      <div style={{ fontSize: "0.8rem", color: "#666" }}>
                        {book.author} • {book.publisher}
                      </div>
                    </div>
                  </div>
                ))
              ) : searchQueryName ? (
                <div className="p-2 text-muted">No results found</div>
              ) : null}
            </div>
          </InputGroup>
        </div>

        <div className="mx-sm-5 mt-sm-5 mt-4 mb-4">
          <div
            className="fw-bold textczoom11  mx-sm-5 mx-auto text-center text-sm-start ftzwork"
            style={{ fontSize: "26px", color: "#919191" }}
          >
            {/* Books & Reviews */}
            {lg.BAndRText}
          </div>

          <div>
            <div className="textczoom11 mx-sm-5 mx-auto  text-center text-sm-start fontupcon fw-bold mt-3 fs-18">
              {lg?.recentlyRated || "Recently rated"}
            </div>
            <div className=" d-none justzomag11 mlmrbook gap-xl-2 gap-1 align-items-center">
              <img
                style={{ rotate: "180deg" }}
                src={require("./image/moveimgarrow.png")}
                width="8"
                height="18"
              />

              {ratedBooksLoading ? (
                <div className="d-flex flex-wrap jucfyy mx-2 gapbooks mt-3">
                  {Array.from({ length: 3 }).map((_, index) => (
                    <BookSkeleton key={`skeleton-rated-desktop-${index}`} />
                  ))}
                </div>
              ) : ratedBooks && (
                <div className="d-flex  flex-wrap jucfyy mx-2 gapbooks mt-3">
                  {ratedBooks?.length === 0 ? (
                    <p className="text-center text-muted">
                      Haven't rated any books yet.
                    </p>
                  ) : (
                    ratedBooks?.map((book, index) => {
                    console.log(
                      "book",
                      book,
                      book?.coverImage?.includes("/uploads/")
                    );
                    return (
                      <Card
                        // key={index}
                        key={book.bookId}
                        className="border-0 align-items-center"
                        style={{ width: "" }}
                      >
                        <Card.Img
                          className="imgsize"
                          variant="top"
                          // src={book.image}
                          // src={`${BASE_URL}/uploadsbook/${book.coverImage}`}
                          src={
                         resolveBookImageUrl(book.coverImage)
                          }

                          style={{
                            width: "110px",
                            height: "160px",
                            cursor: "pointer",
                          }}
                          // onClick={() => navigate("/reviews")}

                          onClick={
                            () => handleSuggestionClickNameRecent(book)

                            // navigate(`/reviews?ean=${book.EAN}&searchbook=true`)
                          }
                        />
                        <Card.Body className=" p-0 mt-1">
                          <div>
                            <span
                              className="mx-2 text-warning "
                              style={{ fontSize: "21px" }}
                            >
                              // ★★★★☆
                              {"★".repeat(book.rating)}
                              {"☆".repeat(5 - book.rating)}
                            </span>
                          </div>
                        </Card.Body>
                      </Card>
                    );
                  })
                )}
              </div>
              )}

              <img
                src={require("./image/moveimgarrow.png")}
                width="8"
                height="18"
              />
            </div>

            {ratedBooksLoading ? (
              <div className="mlmrbook removemlmr my-5 gapbooks mt-3 justify-content-center gap-xl-2 gap-1 align-items-center">
                <Slider {...settingsd}>
                  {Array.from({ length: 3 }).map((_, index) => (
                    <BookSkeleton key={`skeleton-rated-${index}`} />
                  ))}
                </Slider>
              </div>
            ) : ratedBooks && (
              <div className=" mlmrbook removemlmr my-5  gapbooks mt-3  justify-content-center  gap-xl-2 gap-1 align-items-center">
                <Slider {...settingsd}>
                  {ratedBooks?.length === 0 ? (
                    <p className="text-center text-muted">
                      Haven't rated any books yet.
                    </p>
                  ) : (
                    ratedBooks?.map((book, index) => (
                    <Card
                      key={book.bookId}
                      className="border-0 align-items-center"
                      style={{ width: "" }}
                    >
                      <Card.Img
                        className="imgsizffe"
                        alt="booooksss"
                        variant="top"
                        // src={book.image}
                        src={
                          resolveBookImageUrl(book.coverImage)
                        }

                        style={{
                          width: "110px",
                          height: "160px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          // navigate(`/reviews/?ean=${book.EAN}&searchbook=true`);
                          handleSuggestionClickNameRecent(book);
                        }}
                      />
                      <Card.Body className=" p-0 mt-1">
                        <div>
                          <span
                            className="mx-2 text-warning "
                            style={{ fontSize: "21px" }}
                          >
                            {"★".repeat(book.rating)}
                            {"☆".repeat(5 - book.rating)}
                          </span>
                        </div>
                      </Card.Body>
                    </Card>
                  ))
                )}
              </Slider>
            </div>
            )}
          </div>

          <div className="mbsla">
            <div className="textczoom11 mx-sm-5 mx-auto  text-center text-sm-start fontupcon fw-bold mt-4 fs-18"></div>
            {loading ? (
              <div>
                <div className="textczoom11 mx-sm-5 mx-auto  text-center text-sm-start fontupcon fw-bold mt-2 fs-18">
                  {lg?.offlisugg || "Ofellio Suggestions"}
                </div>
                <div className="d-sm-block d-none mlmrbook my-5 gapbooks mt-3 justify-content-start gap-xl-2 gap-1 align-items-center">
                  <Slider {...settingsd}>
                    {Array.from({ length: 6 }).map((_, index) => (
                      <BookSkeleton key={`skeleton-suggestive-${index}`} />
                    ))}
                  </Slider>
                </div>
                <div className="my-4 jucfyydd removemlmr d-sm-none d-block">
                  <Slider {...settings}>
                    {Array.from({ length: 3 }).map((_, index) => (
                      <BookSkeleton key={`skeleton-suggestive-mobile-${index}`} />
                    ))}
                  </Slider>
                </div>
              </div>
            ) : (
              <div>
                <div className="textczoom11 mx-sm-5 mx-auto  text-center text-sm-start fontupcon fw-bold mt-2 fs-18">
                  {lg?.offlisugg || "Ofellio Suggestions"}
                </div>
                <div className="ddd-sm-flex d-none justzomag11 removemlmr mlmrbook gap-2 align-items-center">
                  <img
                    style={{ rotate: "180deg" }}
                    src={require("./image/moveimgarrow.png")}
                    width="8"
                    height="18"
                  />

                  <img
                    src={require("./image/moveimgarrow.png")}
                    width="8"
                    height="18"
                  />
                </div>

                <div className="d-sm-block d-none mlmrbook my-5  gapbooks mt-3  justify-content-start  gap-xl-2 gap-1 align-items-center">
                  <Slider {...settingsd}>
                    {booksByHeading.length > 0 ? (
                      booksByHeading.map((book) => (
                        <Card
                          // key={index}
                          key={book._id}
                          className="border-0 align-items-center"
                          style={{ width: "" }}
                        >
                          <Card.Img
                            className="imgsizffe"
                            variant="top"
                            // src={book.coverImage}
                            src={
                         resolveBookImageUrl(book.coverImage)
                            }

                            alt="suggestivebook"
                            style={{
                              width: "110px",
                              height: "160px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleBookClick(book)}
                          />
                          <Card.Body className=" p-0 mt-0">
                            <div className="mx-2">
                              <span
                                className="mx-auto  "
                                style={{
                                  fontSize: "21px",
                                }}
                              >
                                {/* ★★★★☆ */}
                                <StarRating rating={book?.averageRating} />
                              </span>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <p>No books found under this heading.</p>
                    )}
                  </Slider>
                </div>

                {/* coursol */}
                <div className=" my-4 jucfyydd  removemlmr d-sm-none d-block  ">
                  <Slider
                    {...{
                      ...settings,
                    }}
                  >
                    {booksByHeading.length > 0 ? (
                      booksByHeading.map((book) => (
                        <Card
                          // key={index}
                          key={book._id}
                          className="border-0 align-items-center"
                          style={{ width: "" }}
                        >
                          <Card.Img
                            className="imgsizffe"
                            variant="top"
                            // src={book.coverImage}
                            src={
                         resolveBookImageUrl(book.coverImage)
                            }

                            alt="suggestivebook"
                            style={{
                              width: "113px",
                              height: "170px",
                              cursor: "pointer",
                            }}
                            onClick={() => handleBookClick(book)}
                          />
                          <Card.Body className=" p-0 mt-1">
                            <div className="mx-2">
                              <span
                                className="mx-auto  "
                                style={{
                                  fontSize: "21px",
                                }}
                              >
                                {/* ★★★★☆ */}
                                <StarRating rating={book?.averageRating} />
                              </span>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <p>No books found under this heading.</p>
                    )}
                  </Slider>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="mt-5">
        {/* <Footer3 /> */}
        <Footer2 />
      </div>
    </>
  );
};

export default BooksAndReviews2;
